import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { GetPaidService } from '@app/+payment/services/get-paid.service';

@Component({
  selector: 'vc-deactivate-old-payment',
  templateUrl: './deactivate-old-payment.component.html',
  styleUrls: ['./deactivate-old-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeactivateOldPaymentComponent {
  constructor(public dialogRef: MatDialogRef<DeactivateOldPaymentComponent>, public getPaidService: GetPaidService) {}

  deleteOldTransferMethod() {
    this.getPaidService.deleteTransferMethod().subscribe({ next: () => this.dialogRef.close(true) });
  }
}
